var exports = {
  "yl": "cliInstallCta__oGINW1",
  "Lf": "customInputContainer__zuLDy-",
  "pT": "customInputCopyButton__8a1TpO",
  "zM": "customInputCode__5s6dju",
  "h0": "installMethodButton__sKiPp-",
  "IK": "customInputCopyIcon__v-0_rS",
  "PD": "desktopOnly__dLgouA",
  "nD": "mobileOnly__y-spwm",
};

module.exports = exports;
